/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiModulesDropdownListParams = zod.strictObject({
    exclude: zod.string().optional(),
    format: zod.enum(['csv', 'json']).optional(),
    order: zod.string().optional(),
    search: zod.string().optional(),
});

export type ApiModulesDropdownListParams = zod.input<
    typeof ApiModulesDropdownListParams
>;
export type ApiModulesDropdownListParamsOutput = zod.output<
    typeof ApiModulesDropdownListParams
>;
